var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomminus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_78_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "zoom_out_FILL0_wght400_GRAD0_opsz48",
    d: "m23.47,25l-9.13-9.13c-.72.61-1.54,1.09-2.43,1.41-.95.34-1.95.51-2.95.5-2.39.05-4.69-.89-6.35-2.6C.91,13.53-.04,11.25,0,8.89c-.04-2.36.9-4.64,2.6-6.28C4.26.9,6.55-.04,8.92,0c2.36-.04,4.63.9,6.27,2.6,1.69,1.65,2.63,3.92,2.59,6.28,0,.98-.16,1.96-.49,2.88-.33.94-.83,1.82-1.46,2.6l9.17,9.1-1.53,1.53Zm-14.55-9.31c1.81.03,3.54-.7,4.79-2,1.29-1.26,2.01-3,1.98-4.81.03-1.81-.69-3.55-1.98-4.81-1.25-1.3-2.99-2.03-4.79-2-1.82-.03-3.57.69-4.84,2-1.3,1.26-2.03,3-2,4.81-.03,1.81.7,3.55,2,4.81,1.27,1.31,3.02,2.03,4.84,2Zm-3.54-5.8v-2.08h6.98v2.08h-6.98Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomminus);
export default __webpack_public_path__ + "static/media/zoomminus.75cfe6d7b1db131653673d6448d7ccc9.svg";
export { ForwardRef as ReactComponent };